import { render, staticRenderFns } from "./AddNewBar.vue?vue&type=template&id=3c3f4d5b"
import script from "./AddNewBar.vue?vue&type=script&lang=js"
export * from "./AddNewBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/nginx/html/staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c3f4d5b')) {
      api.createRecord('3c3f4d5b', component.options)
    } else {
      api.reload('3c3f4d5b', component.options)
    }
    module.hot.accept("./AddNewBar.vue?vue&type=template&id=3c3f4d5b", function () {
      api.rerender('3c3f4d5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/AddNewBar.vue"
export default component.exports